import { render, staticRenderFns } from "./FooterComp.vue?vue&type=template&id=65b3cc41&scoped=true&"
import script from "./FooterComp.vue?vue&type=script&lang=js&"
export * from "./FooterComp.vue?vue&type=script&lang=js&"
import style0 from "./FooterComp.vue?vue&type=style&index=0&id=65b3cc41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b3cc41",
  null
  
)

component.options.__file = "FooterComp.vue"
export default component.exports